<template>
  <div id="CategoryView" class="category-viwe-layout">
    <v-row
      ><v-col cols="12">
        <v-card outlined>
          <v-card-title>{{ $t("vendor.headerStep2") }}</v-card-title>
          <v-card-text>
            <v-data-table
              :headers="headers"
              :items="showTable"
              :loading="loadingProject"
              loading-text="Loading... Please wait"
            ></v-data-table></v-card-text></v-card></v-col
    ></v-row>
  </div>
</template>

<script>
import { vendorservice } from "../../services/vendorservice";

export default {
  name: "CategoryView",
  data: () => ({
    vendorCatListModel: [],
    showTable: [],
    headers: [
      { text: "Category", value: "categoryName" },
      { text: "Sub Category", value: "subCategoryName" },
    ],
    loadingProject: false,
  }),
  async mounted() {
    await this.getCatList();
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser;
    },
  },
  methods: {
    async getCatList() {
      this.loadingProject = true;
      this.vendorCatListModel = await vendorservice.GetVendorCategory(
        this.$store.state.AppActiveUser.userName,
        this.$store.state.AppActiveUser.vendorID
      );
      this.showTable = await this.newData(this.vendorCatListModel);
      this.loadingProject = false;
    },
    newData(data) {
      let result = [];
      for (let i = 0; i < data.length; i++) {
        if (data[i].isActive) {
          const element = {
            ...data[i],
          };
          result.push(element);
        }
      }

      return result;
    },
  },
};
</script>
